<form [formGroup]="form">
	<div class="company-scope">
		<div class="iaf-scopes-wrapper">
			@if (!(iso27xScopeFixed$ | async)) {
				<div class="iaf-scopes">
					<div class="iaf-scopes-label-wrapper">
						<label for="scope-selector-{{standard.toLowerCase()}}" class="label">{{ 'company-general-info.company-scope.label' | translate }}</label>
						<svg-icon src="assets/icons/info.svg" class="info-icon" [nbPopover]="iafScopesPopover" nbPopoverPlacement="bottom"></svg-icon>
					</div>
					<ng-select id="scope-selector-{{standard.toLowerCase()}}" #scopeSelector [items]="stringScopes" [multiple]="true" [searchFn]="searchScopesFn"
							   [notFoundText]="'common.not-found' | translate"
							   labelForId="company-scopes" [clearable]="false" [closeOnSelect]="false" [dropdownPosition]="'bottom'"
							   [placeholder]="'company-general-info.company-scope.placeholder' | translate"
							   formControlName="{{fullControlName('companyScopes')}}" [attr.formcontrolname]="fullControlName('companyScopes')">
						<ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
							<nb-checkbox class="scope-checkbox-item" id="item-{{index}}-{{product.standard.name.toLowerCase()}}" [checked]="item$.selected" [status]="'primary'"
										 (checkedChange)="selectScope($event, item$)" (click)="$event.stopPropagation()">{{ item }}
							</nb-checkbox>
						</ng-template>
					</ng-select>
					@if (isInvalid('companyScopes')) {
						<div class="validation-message">{{ getValidationErrors('companyScopes') | async }}</div>
					}
				</div>
			} @else {
				<div class="iso27-scope">
					<label class="label">{{ 'company-general-info.company-scope.scope-label' | translate }}</label>
					<div class="read-only-scope">{{ stringScopes[0] }}</div>
				</div>
			}

			<div [ngClass]="isIso27x01Product ? 'employees-within-scope-27x01' : 'employees-within-scope'">
				@if (product.scopeDescriptionNeedsNarrowing) {
					<employees-input [idPrefix]="'employees-within-scope-'" [form]="form" [controlName]="'employeesWithinScope'"
									 [connectedEmployeesControl]="'employeesCount'" [isClientInput]="isClientInput" [standard]="standard"
									 [label]="'company-general-info.company-scope.employee-within' | translate"
									 [popoverPlacement]="'left'"></employees-input>
				}
			</div>
		</div>

		<div class="scope-questions">
			@for (selectedScope of product.scopes; track trackByScopesFcn($index, selectedScope)) {
				<div>
					@if (hasScopeQuestions(selectedScope)) {
						<div class="scope-question">
							<label class="company-input-label label">{{ selectedScope | scopeToString }}</label>
							@for (question of getScopeQuestions(selectedScope); track question.type; let i = $index) {
								<div class="form-row scope-questions">
									<div class="form-input">
										<nb-radio-group id="{{getControlNameForScopeQuestion(selectedScope, i)}}_{{product.standard.name.toLowerCase()}}"
														name="{{getControlNameForScopeQuestion(selectedScope, i)}}_{{product.standard.name.toLowerCase()}}"
														[status]="isInvalid(getControlNameForScopeQuestion(selectedScope, i)) ? 'danger' : 'primary'"
														[formControlName]="getControlNameForScopeQuestion(selectedScope, i)" [attr.formcontrolname]="getControlNameForScopeQuestion(selectedScope, i)"
														(valueChange)="updateFormControl(getControlNameForScopeQuestion(selectedScope, i), $event)"
														[disabled]="shouldDisableRadio(getControlNameForScopeQuestion(selectedScope, i))">
											<nb-radio name="yes" [value]="true">{{ 'common.yes' | translate }}</nb-radio>
											<nb-radio name="no" [value]="false">{{ 'common.no' | translate }}</nb-radio>
										</nb-radio-group>
										@if (isInvalid(getControlNameForScopeQuestion(selectedScope, i))) {
											<div class="validation-message"
											>{{ getValidationErrors(getControlNameForScopeQuestion(selectedScope, i)) | async }}
											</div>
										}
									</div>
									<div class="form-input scope-question-text">
										{{ question.text }}
									</div>
								</div>
							}
						</div>
					}
				</div>
			}
		</div>
	</div>
</form>

<ng-template #iafScopesPopover>
	<nb-card class="scopes-explanation-card">
		<nb-card-body class="explanation-body">
			<div class="description">{{ 'company-general-info.company-scope.description' | translate }}</div>
			<nb-icon class="close-icon" icon="close-circle-outline" (click)="popover.hide()"></nb-icon>
		</nb-card-body>
	</nb-card>
</ng-template>
